import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building, CreditCard, AtSign, Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AccountType } from "@/types/payment";
interface SignupStepThreeProps {
  paymentTab: "bank" | "paypay";
  setPaymentTab: (tab: "bank" | "paypay") => void;
  bankName: string;
  setBankName: (name: string) => void;
  branchName: string;
  setBranchName: (name: string) => void;
  accountType: AccountType;
  setAccountType: (type: AccountType) => void;
  accountNumber: string;
  setAccountNumber: (number: string) => void;
  accountHolderName: string;
  setAccountHolderName: (name: string) => void;
  paypayUsername: string;
  setPaypayUsername: (username: string) => void;
}
export const SignupStepThree = ({
  paymentTab,
  setPaymentTab,
  bankName,
  setBankName,
  branchName,
  setBranchName,
  accountType,
  setAccountType,
  accountNumber,
  setAccountNumber,
  accountHolderName,
  setAccountHolderName,
  paypayUsername,
  setPaypayUsername
}: SignupStepThreeProps) => {
  const {
    t
  } = useTranslation();
  return <div className="space-y-4">
      <div className="text-center space-y-2">
        <p className="text-sm text-muted-foreground mb-4">
          {t('auth.paymentDescription')}
        </p>
        
        
      </div>

      <Tabs value={paymentTab} onValueChange={value => setPaymentTab(value as "bank" | "paypay")} className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-2">
          <TabsTrigger value="paypay" className="py-2.5">
            <CreditCard className="mr-2 h-4 w-4" />
            PayPay
          </TabsTrigger>
          <TabsTrigger value="bank" className="py-2.5">
            <Building className="mr-2 h-4 w-4" />
            {t('payments.bank')}
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="paypay" className="mt-4 px-1">
          <div className="space-y-2 mb-3">
            <h3 className="text-md font-medium flex items-center gap-2">
              <div className="bg-[#FFDEE2] p-1.5 rounded-full">
                <CreditCard className="h-4 w-4 text-[#ff66c4]" />
              </div>
              {t('auth.paypayDetails')}
            </h3>
            <p className="text-xs text-muted-foreground">{t('auth.paypayDesc')}</p>
          </div>
          
          <div className="flex flex-col space-y-4">
            
            <div className="relative">
              <Input id="paypayUsername" placeholder={t('auth.paypayUsernamePlaceholder')} value={paypayUsername} onChange={e => setPaypayUsername(e.target.value)} className="pl-10 border-[#ff66c4]/20 focus-visible:ring-[#ff66c4]/30" />
              <AtSign className="absolute left-3 top-2.5 h-5 w-5 text-[#ff66c4]/60" />
            </div>
            <p className="text-xs text-gray-500">
              {t('payments.paypayHint')}
            </p>
          </div>
        </TabsContent>
        
        <TabsContent value="bank" className="mt-4 space-y-3 px-1">
          <div className="space-y-1 mb-1">
            <h3 className="text-md font-medium flex items-center gap-2">
              <div className="bg-[#e5deff] p-1.5 rounded-full">
                <Building className="h-4 w-4 text-[#5770fd]" />
              </div>
              {t('auth.bankDetails')}
            </h3>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label htmlFor="bankName">{t('auth.bankName')}</Label>
              <Input id="bankName" placeholder={t('auth.bankNamePlaceholder')} value={bankName} onChange={e => setBankName(e.target.value)} className="border-[#5770fd]/20 focus-visible:ring-[#5770fd]/30" />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="branchName">{t('auth.branchName')}</Label>
              <Input id="branchName" placeholder={t('auth.branchNamePlaceholder')} value={branchName} onChange={e => setBranchName(e.target.value)} className="border-[#5770fd]/20 focus-visible:ring-[#5770fd]/30" />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="accountType">{t('auth.accountType')}</Label>
            <div className="flex gap-2">
              <Button type="button" variant={accountType === "普通預金" ? "default" : "outline"} onClick={() => setAccountType("普通預金")} className="flex-1 border-[#5770fd]/20">
                {t('auth.savings')}
              </Button>
              <Button type="button" variant={accountType === "当座預金" ? "default" : "outline"} onClick={() => setAccountType("当座預金")} className="flex-1 border-[#5770fd]/20">
                {t('auth.checking')}
              </Button>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label htmlFor="accountNumber">{t('auth.accountNumber')}</Label>
              <Input id="accountNumber" placeholder={t('auth.accountNumberPlaceholder')} value={accountNumber} onChange={e => setAccountNumber(e.target.value)} className="border-[#5770fd]/20 focus-visible:ring-[#5770fd]/30" />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="accountHolderName">{t('auth.accountHolder')}</Label>
              <Input id="accountHolderName" placeholder={t('auth.accountHolderPlaceholder')} value={accountHolderName} onChange={e => setAccountHolderName(e.target.value)} className="border-[#5770fd]/20 focus-visible:ring-[#5770fd]/30" />
            </div>
          </div>
        </TabsContent>
      </Tabs>
      
      <div className="pt-2">
        <p className="text-sm text-center mb-2 text-primary/60">
          <Trophy className="inline-block h-4 w-4 mr-1" />
          {t('auth.unlockPayment')}
        </p>
      </div>
    </div>;
};